import { sendCustomError } from "@otto-ec/global-resources/apm";
import { extendScope } from "./utils";

/**
 *
 *
 *
 *
 */
const PROP_DEF_KEY = "$$p_d";

const log = extendScope.scope("cleanup");

/**
 *
 *
 *
 *
 *
 *
 */
export function cleanUpFalsyBooleanAttributes(host: HTMLElement): void {
  const propDefs = (host as never)[PROP_DEF_KEY] as
    | Record<string, { type: string; attribute?: string }>
    | undefined;

  if (!propDefs) return;

  /*                                                          */
  if (typeof propDefs !== "object") {
    log.error("Could not find property definitions on", host, "by", PROP_DEF_KEY);
    sendCustomError(
      "oc-prop-definitions-not-found",
      `Could not find property definitions on element: ${host.tagName.toLowerCase()}`,
      {
        component: host.tagName.toLowerCase(),
        propDefKey: PROP_DEF_KEY,
      },
    );
    return;
  }

  /*                                           */
  const booleanDefs = Object.entries(propDefs)
    .filter(([, def]) => !!def && typeof def === "object" && def.type === "Boolean")
    .map(([propName]) => propName);
  if (booleanDefs.length === 0) return;

  /*                                                                                  */
  /*                                  */
  host.getAttributeNames().forEach((attrName) => {
    if (!booleanDefs.includes(attrName) || host.getAttribute(attrName) !== "false") return;
    host.removeAttribute(attrName);
  });
}
